/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CreateUpdateAccountStrutturaBusinessDto interface.
 */
export function instanceOfCreateUpdateAccountStrutturaBusinessDto(value) {
    return true;
}
export function CreateUpdateAccountStrutturaBusinessDtoFromJSON(json) {
    return CreateUpdateAccountStrutturaBusinessDtoFromJSONTyped(json, false);
}
export function CreateUpdateAccountStrutturaBusinessDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'idAccount': json['idAccount'] == null ? undefined : json['idAccount'],
        'idStrutturaBusiness': json['idStrutturaBusiness'] == null ? undefined : json['idStrutturaBusiness'],
    };
}
export function CreateUpdateAccountStrutturaBusinessDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'idAccount': value['idAccount'],
        'idStrutturaBusiness': value['idStrutturaBusiness'],
    };
}
